import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Heart, X } from "lucide-react";

const KEY = "refugium_launch_banner_dismissed";

export default function LaunchBanner() {
  const [show, setShow] = useState(false);
  const [donate, setDonate] = useState("https://gofund.me/15d8987b7");

  useEffect(() => {
    if (localStorage.getItem(KEY) !== "1") setShow(true);
    api.get("/settings").then(({ data }) => data.gofundme_url && setDonate(data.gofundme_url)).catch(() => {});
  }, []);

  const dismiss = () => { localStorage.setItem(KEY, "1"); setShow(false); };

  if (!show) return null;

  return (
    <div className="bg-[#C1272D] text-white" data-testid="launch-banner">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2.5 flex items-center justify-center gap-3 text-center relative">
        <p className="text-sm font-medium flex items-center gap-2 flex-wrap justify-center">
          <Heart size={15} fill="white" className="shrink-0" />
          <span>We just launched — <span className="font-bold">be our first supporter.</span></span>
          <a href={donate} target="_blank" rel="noopener noreferrer" data-testid="launch-banner-donate"
            className="underline underline-offset-2 font-bold hover:text-[#F2ECDD] transition-colors">Donate now →</a>
        </p>
        <button onClick={dismiss} data-testid="launch-banner-close" aria-label="Dismiss"
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white transition-colors">
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
